export default (initialState = {}) => {
  return () => {
    return {
      transfer_from_bank: null,
      reference_number: null,
      payment_description: null,
      mode: "RTGS",
      date: new Date(),
      time: new Date(),
      ...initialState,
    };
  };
};
